import TabNav from "components/TabNav";
import React, { useState } from "react";
import {
    LEGAL_RESEARCH_PROSECUTOR_TAB,
    LEGAL_RESEARCH_PROSECUTOR_TABS, LEGAL_RESEARCH_REQUEST_STATUS,
} from "utils/constantValues";
import LeftPanel from "./fragments/leftPanel";
import RightPanel from "./fragments/rightPanel";
import { updateLegalResearchRequest } from "services/legalResearchService";
import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";

interface DirectorLegalResearchProps {
    request: any;
    isCommittee?: boolean;
}

 const SingleConductLegalResearch: React.FC<DirectorLegalResearchProps> = ({
     request,
     isCommittee = false,
 }) => {
     const { showToast } = useToast();
     const contextData = useAuth();
     const [activeTab, setActiveTab] = useState<string>("Proposal Document");
     const [formState, setFormState] = useState({
         ...request,
         urgency_level: request?.urgency_level
             ? request?.urgency_level.charAt(0).toUpperCase() +
               request?.urgency_level.slice(1).toLowerCase()
             : "High",
     });
     const [broadcastLoading, setBroadcastLoading] = useState(false);
     const [forwardLoading, setForwardLoading] = useState(false);

     const handleBroadcast = async (isPublished: boolean) => {
         setBroadcastLoading(true);
         const updateData = new FormData();
         updateData.append("is_published", isPublished.toString());
         try {
             const response = await updateLegalResearchRequest(request.id, updateData, contextData.token || contextData.user.access_token || "");
             setFormState((prev: any) => ({ ...prev, is_published: isPublished }));
             showToast(isPublished ? "Research broadcasted to public!" : "Research unpublished!", "success");
         } catch (error) {
             console.error("Error updating broadcast status:", error);
             showToast("Failed to update broadcast status.", "error");
         } finally {
             setBroadcastLoading(false);
         }
     };

     const handleForward = async () => {
         setForwardLoading(true);
         const updateData = new FormData();
         updateData.append("forward_status", LEGAL_RESEARCH_REQUEST_STATUS.forwarded_to_coordinator.value);
         try {
             const response = await updateLegalResearchRequest(request.id, updateData, contextData.token || contextData.user.access_token || "");
             setFormState(response);
             showToast("Forwarded to Coordinator!", "success");
         } catch (error) {
             console.error("Error forwarding:", error);
             showToast("Failed to forward.", "error");
         } finally {
             setForwardLoading(false);
         }
     };

    return (
        <div className="flex flex-col h-full bg-gray-100">
            {formState.requested_by !== "internal" && <TabNav
                active={activeTab}
                tabs={(formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.research_underway.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_submitted.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_revision.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_approved.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.completed.value || formState?.documents.find((document: any) => document.document_type === "research_draft_file")) ?
                    LEGAL_RESEARCH_PROSECUTOR_TABS : LEGAL_RESEARCH_PROSECUTOR_TAB}
                onSelect={setActiveTab}
            />}
            <div className="flex flex-1 overflow-hidden">
                <LeftPanel
                  activeTab={activeTab}
                  request={request}
                  showBroadcast={true}
                  onBroadcast={handleBroadcast}
                  showForward={formState.forward_status === LEGAL_RESEARCH_REQUEST_STATUS.forwarded_to_director.value && formState.status === LEGAL_RESEARCH_REQUEST_STATUS.research_committee_acceptd.value}
                  onForward={handleForward}
                  broadcastLoading={broadcastLoading}
                />
                <RightPanel request={request} />
            </div>
        </div>
    );
};

export default SingleConductLegalResearch;

